import * as actionTypes from "../actionTypes";

export const getServiceReport = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REPORT_START,
    payload: data,
  };
};
export const getServiceReportSuccess = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REPORT_SUCCESS,
    payload: data,
  };
};
export const getServiceReportFailure = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REPORT_FAILURE,
    payload: data,
  };
};

// label service actions
export const getLabelServiceReport = (data) => {
  return {
    type: actionTypes.GET_LABEL_SERVICE_REPORT_START,
    payload: data,
  };
};
export const getLabelServiceReportSuccess = (data) => {
  return {
    type: actionTypes.GET_LABEL_SERVICE_REPORT_SUCCESS,
    payload: data,
  };
};
export const getLabelServiceReportFailure = (data) => {
  return {
    type: actionTypes.GET_LABEL_SERVICE_REPORT_FAILURE,
    payload: data,
  };
};

export const generateReport = (data) => {
  return {
    type: actionTypes.GENERATE_REPORT_START,
    payload: data,
  };
};
export const generateReportSuccess = (data) => {
  return {
    type: actionTypes.GENERATE_REPORT_SUCCESS,
    payload: data,
  };
};
export const setLoading = (data) => {
  return {
    type: actionTypes.SET_LOADING,
    payload: data,
  };
};
export const generateReportFailure = (data) => {
  return {
    type: actionTypes.GENERATE_REPORT_FAILURE,
    payload: data,
  };
};

export const getContentReport = (data) => {
  return {
    type: actionTypes.GET_CONTENT_REPORT_START,
    payload: data,
  };
};
export const getContentReportSuccess = (data) => {
  return {
    type: actionTypes.GET_CONTENT_REPORT_SUCCESS,
    payload: data,
  };
};
export const getContentReportFailure = (data) => {
  return {
    type: actionTypes.GET_CONTENT_REPORT_FAILURE,
    payload: data,
  };
};

export const reportLogs = (data) => {
  return {
    type: actionTypes.CLEAR_REPORT_LOGS_START,
    payload: data
  };
};
export const reportLogsSuccess = (data) => {
  return {
    type: actionTypes.CLEAR_REPORT_LOGS_SUCCESS,
    payload: data,
  };
};
export const reportLogsFailure = (data) => {
  return {
    type: actionTypes.CLEAR_REPORT_LOGS_FAILURE,
    payload: data,
  };
};

export const  serviceReportMessageHandler = () => {
  return {
    type: actionTypes.SERVICE_REPORT_MESSAGE_HANDLER,
    payload: null,
  };
};
